import React, { useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons'
import { NewFolder } from 'models/folder.model'
import Options from '../options/Options'
import { ErrorToast } from 'components/ui/toast/toastsTemplates'
import { useDispatch } from 'react-redux'
import * as fromActions from 'store/actions/folders.action'
import styles from '../List.module.scss'
import { useTranslation } from 'react-i18next'

interface IProps {
  setShowCreate: any
  lastItemOrder: number
}

const New: React.FC<IProps> = ({ setShowCreate, lastItemOrder }) => {
  const { t } = useTranslation()

  const nameFolderRef = useRef<HTMLInputElement>(null)

  const dispatch = useDispatch()

  const onCreateClick = () => {
    const { current } = nameFolderRef

    if (current && current?.value != '') {
      const folder = NewFolder(current.value, lastItemOrder)
      setShowCreate(false)
      current.value = ''

      dispatch({ type: fromActions.CREATE_FOLDER, payload: { folder } })
    } else {
      ErrorToast(t('administration.folders.new.validations.name'))
    }
  }

  return (
    <div className="border-bottom d-flex justify-content-between align-items-center p-2 pl-3">
      <div className={styles.inputContainer}>
        <FontAwesomeIcon
          size="1x"
          icon={faChevronDown}
          className={styles.createArrow}
        />
        <input
          type="text"
          ref={nameFolderRef}
          className={styles.inputFolders}
        />
      </div>
      <div className="d-flex justify-content-between align-items-center w-25">
        <span
          className="text-muted"
          role="button"
          onClick={() => setShowCreate(false)}
        >
          {t('administration.folders.new.buttons.cancel')}
        </span>
        <span className="text-success" role="button" onClick={onCreateClick}>
          {t('administration.folders.new.buttons.save')}
        </span>
        <Options
          item={null}
          onEditClick={null}
          onDeleteClick={null}
          disable={true}
        />
      </div>
    </div>
  )
}

export default New
